export const PAGES_GET = 'PAGES_GET';
export const PAGE_CATEGORYOPTS_GET = 'PAGE_CATEGORYOPTS_GET';
export const PAGE_ADD = 'PAGE_ADD';
export const PAGE_EDIT = 'PAGE_EDIT';
export const PAGE_UPLOADFILE = 'PAGE_UPLOADFILE';
export const PAGE_GET = 'PAGE_GET';
export const PAGE_DELETE = 'PAGE_DELETE';
